function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.0003 4.64C14.2536 4.64 15.7736 5.61333 16.6403 6.42667L20.0269 3.12C17.9469 1.18667 15.2403 0 12.0003 0C7.30694 0 3.25361 2.69333 1.28027 6.61333L5.16027 9.62667C6.13361 6.73333 8.82694 4.64 12.0003 4.64Z",
  fill: "#EA4335"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M23.52 12.2667C23.52 11.28 23.44 10.56 23.2667 9.81335H12V14.2667H18.6133C18.48 15.3734 17.76 17.04 16.16 18.16L19.9467 21.0934C22.2133 19 23.52 15.92 23.52 12.2667Z",
  fill: "#4285F4"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.17333 14.3738C4.92 13.6271 4.77333 12.8271 4.77333 12.0004C4.77333 11.1738 4.92 10.3738 5.16 9.6271L1.28 6.61377C0.466667 8.24044 0 10.0671 0 12.0004C0 13.9338 0.466667 15.7604 1.28 17.3871L5.17333 14.3738Z",
  fill: "#FBBC05"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9996 24.0002C15.2396 24.0002 17.9596 22.9335 19.9463 21.0935L16.1596 18.1602C15.1463 18.8669 13.7863 19.3602 11.9996 19.3602C8.8263 19.3602 6.13297 17.2669 5.17297 14.3735L1.29297 17.3869C3.2663 21.3069 7.3063 24.0002 11.9996 24.0002Z",
  fill: "#34A853"
});

var SvgGoogle = function SvgGoogle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google.44e8a640.svg";
export { ForwardRef as ReactComponent };